<template>
  <v-row>
    <v-col cols="12">
      <router-link to="/results">
        <span class="primary--text">Kembali</span>
      </router-link>
    </v-col>

    <template v-if="loading">
      <v-col cols="12">
        <v-skeleton-loader height="24" loading type="image" />
      </v-col>
      <v-col cols="12">
        <v-skeleton-loader height="128" loading type="image" />
      </v-col>
    </template>

    <template v-else-if="result">
      <v-col cols="12">
        <div class="text-h5">Detail Hasil Test - {{ result.license }}</div>
      </v-col>

      <v-col cols="12">
        <v-card class="px-4">
          <v-row>
            <v-col cols="12" md="6">
              <div class="font-weight-medium" style="font-size: 1.25rem">
                Biodata
              </div>
              <table
                style="table-layout: fixed; width: 100%; border-spacing: 0 16px"
              >
                <tbody>
                  <tr>
                    <td class="text-left">Kode Lisensi</td>
                    <td class="text-left">{{ result.license }}</td>
                  </tr>
                  <tr>
                    <td class="text-left">Nama</td>
                    <td class="text-left">{{ result.member.fullname }}</td>
                  </tr>
                  <tr>
                    <td class="text-left">Email</td>
                    <td class="text-left">{{ result.member.email }}</td>
                  </tr>
                  <tr>
                    <td class="text-left">Waktu Mulai Tes</td>
                    <td class="text-left">
                      {{ result.start_test_at | toLocaleDate }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Waktu Selesai Tes</td>
                    <td class="text-left">
                      {{ result.end_test_at | toLocaleDate }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Tes ID</td>
                    <td class="text-left">{{ result.id }}</td>
                  </tr>
                </tbody>
              </table>
            </v-col>
            <v-col cols="12" md="6">
              <div class="font-weight-medium" style="font-size: 1.25rem">
                Hasil
              </div>
              <table
                style="table-layout: fixed; width: 100%; border-spacing: 0 16px"
              >
                <tbody>
                  <tr>
                    <td class="text-left">Program</td>
                    <td class="text-left">{{ result.program.title }}</td>
                  </tr>
                  <tr>
                    <td class="text-left">Topik</td>
                    <td class="text-left">
                      {{ result.topics.map((v) => v.name).join(", ") }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Hasil</td>
                    <td class="text-left">{{ result.results.score }}</td>
                  </tr>
                </tbody>
              </table>
            </v-col>

            <v-col cols="12">
              <v-divider />
            </v-col>

            <v-col cols="12">
              <div class="font-weight-medium" style="font-size: 1.25rem">
                Hasil tes
              </div>
              <template v-if="result && result.topics">
                <v-row
                  v-for="(topic, indexTopic) in result.topics"
                  :key="topic.id"
                >
                  <v-col cols="12">
                    <div class="text-h5">
                      Topik {{ indexTopic + 1 }} - {{ topic.name }}
                    </div>
                  </v-col>

                  <v-col
                    cols="12"
                    v-for="(activity, indexAct) in topic.activities"
                    :key="activity.id"
                  >
                    <div
                      class="font-weight-medium mb-2"
                      style="font-size: 1.25rem"
                    >
                      Aktivitas {{ indexAct + 1 }} - {{ activity.title }}
                    </div>

                    <div class="font-weight-medium mb-2">
                      Score: {{ activity.score }}
                    </div>
                    <div class="mb-2">
                      disubmit pada: {{ activity.end_test | toLocaleDate }}
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-divider />
                  </v-col>
                </v-row>
              </template>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card class="px-4">
          <v-row>
            <v-col cols="12">
              <v-tabs hide-slider class="mb-4" v-model="tabs">
                <v-tab>Foto ketika tes</v-tab>
                <v-tab>Pelanggaran tab</v-tab>
                <v-tab>Pelanggaran multiwajah</v-tab>
                <v-tab>Pelanggaran suara</v-tab>
              </v-tabs>

              <v-tabs-items v-model="tabs">
                <v-tab-item>
                  <template v-if="result && result.topics">
                    <v-row
                      v-for="(topic, indexTopic) in result.topics"
                      :key="topic.id"
                    >
                      <v-col cols="12">
                        <div class="text-h5">
                          Topik {{ indexTopic + 1 }} - {{ topic.name }}
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        v-for="(activity, indexAct) in topic.activities"
                        :key="activity.id"
                      >
                        <div
                          class="font-weight-medium"
                          style="font-size: 1.25rem"
                        >
                          Aktivitas {{ indexAct + 1 }} - {{ activity.title }}
                        </div>

                        <template
                          v-if="
                            activity.face_capture_data &&
                            activity.face_capture_data.length
                          "
                        >
                          <div class="mb-2">
                            Tangkapan foto selama sesi berlangsung
                          </div>

                          <v-row>
                            <v-col
                              v-for="data in activity.face_capture_data"
                              class="pt-1 text-center"
                              cols="12"
                              sm="6"
                              :key="data.created_at"
                            >
                              <img :src="data.media.url" />
                            </v-col>
                          </v-row>
                        </template>

                        <div v-else class="mb-2 gray--text">
                          Tidak ada tangkapan foto selama aktivitas berlangsung
                        </div>
                      </v-col>
                      <v-col cols="12">
                        <v-divider />
                      </v-col>
                    </v-row>
                  </template>
                </v-tab-item>
                <v-tab-item>
                  <template v-if="result && result.topics">
                    <v-row
                      v-for="(topic, indexTopic) in result.topics"
                      :key="topic.id"
                    >
                      <v-col cols="12">
                        <div class="text-h5">
                          Topik {{ indexTopic + 1 }} - {{ topic.name }}
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        v-for="(activity, indexAct) in topic.activities"
                        :key="activity.id"
                      >
                        <div
                          class="font-weight-medium"
                          style="font-size: 1.25rem"
                        >
                          Aktivitas {{ indexAct + 1 }} - {{ activity.title }}
                        </div>

                        <div class="mb-2">
                          Jumlah pelanggaran tab baru selama aktivitas:
                          {{ activity.violation.open_new_tab.total }}x
                        </div>
                      </v-col>
                      <v-col cols="12">
                        <v-divider />
                      </v-col>
                    </v-row>
                  </template>

                  <v-row>
                    <v-col cols="12">
                      <div
                        class="font-weight-medium"
                        style="font-size: 1.25rem"
                      >
                        Total pelanggaran tab baru:
                        {{ total_violation.new_tab }}x
                      </div>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <template v-if="result && result.topics">
                    <v-row
                      v-for="(topic, indexTopic) in result.topics"
                      :key="topic.id"
                    >
                      <v-col cols="12">
                        <div class="text-h5">
                          Topik {{ indexTopic + 1 }} - {{ topic.name }}
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        v-for="(activity, indexAct) in topic.activities"
                        :key="activity.id"
                      >
                        <div
                          class="font-weight-medium"
                          style="font-size: 1.25rem"
                        >
                          Aktivitas {{ indexAct + 1 }} - {{ activity.title }}
                        </div>

                        <div class="mb-2">
                          Jumlah pelanggaran wajah ganda selama aktivitas:
                          {{ activity.violation.multi_face_detection.total }}x
                        </div>

                        <v-row
                          v-if="activity.violation.multi_face_detection.total"
                        >
                          <v-col class="pt-1" cols="12">
                            <div class="mb-2">Foto saat pelanggaran</div>
                            <div class="d-flex text-center flex-wrap">
                              <img
                                v-for="photo in activity.violation
                                  .multi_face_detection.data"
                                :key="photo.media.url"
                                class="ma-2"
                                :src="photo.media.url"
                              />
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-divider />
                      </v-col>
                    </v-row>
                  </template>

                  <v-row>
                    <v-col cols="12">
                      <div
                        class="font-weight-medium"
                        style="font-size: 1.25rem"
                      >
                        Total pelanggaran multi wajah:
                        {{ total_violation.multi_face }}x
                      </div>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <template v-if="result && result.topics">
                    <v-row
                      v-for="(topic, indexTopic) in result.topics"
                      :key="topic.id"
                    >
                      <v-col cols="12">
                        <div class="text-h5">
                          Topik {{ indexTopic + 1 }} - {{ topic.name }}
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                        v-for="(activity, indexAct) in topic.activities"
                        :key="activity.id"
                      >
                        <div
                          class="font-weight-medium"
                          style="font-size: 1.25rem"
                        >
                          Aktivitas {{ indexAct + 1 }} - {{ activity.title }}
                        </div>
                        <v-row>
                          <v-col class="pt-1" cols="12">
                            <div class="mb-2">
                              Jumlah pelanggaran suara selama aktivitas:
                              {{ activity.violation.chat_detection.total }}x
                            </div>
                            <ul v-if="activity.violation.chat_detection.total">
                              <li
                                v-for="(result, index) in activity.violation
                                  .chat_detection.data"
                                :key="index"
                              >
                                {{ result.text }}
                              </li>
                            </ul>
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col cols="12">
                        <v-divider />
                      </v-col>
                    </v-row>
                  </template>
                  <v-row>
                    <v-col cols="12">
                      <div
                        class="font-weight-medium"
                        style="font-size: 1.25rem"
                      >
                        Total pelanggaran suara:
                        {{ total_violation.chat_discussion }}x
                      </div>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    tabs: 0,
    loading: false,
    result: null,
  }),
  computed: {
    srcimg() {
      return "data:image/jpeg;base64,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";
    },
    total_violation() {
      if (!this.result) return {};
      const activities = this.result.topics.reduce((cur, car) => {
        return [...cur, ...car.activities];
      }, []);
      const violations = activities.map((v) => v.violation);
      const new_tab = violations.reduce(
        (cur, car) => cur + car.open_new_tab.total,
        0
      );
      const multi_face = violations.reduce(
        (cur, car) => cur + car.multi_face_detection.total,
        0
      );
      const chat_discussion = violations.reduce(
        (cur, car) => cur + car.chat_detection.total,
        0
      );
      return {
        new_tab,
        multi_face,
        chat_discussion,
      };
    },
  },
  mounted() {
    this.$root.$emit("set-page-title", "Detail Hasil Test");
    this.fetchDetail();
  },
  filters: {
    toLocaleDate(raw_date) {
      // const date = new Date(raw_date.slice(0,10))
      // "2023-05-26T02:46:22.117Z"
      if (!raw_date) return "-";
      const hours = (parseInt(raw_date.slice(11, 13)) + 7)
        .toString()
        .padStart(2, 0);
      return `${raw_date.slice(0, 10)} ${hours}:${raw_date.slice(14, 19)} WIB`;
      //  date.toLocaleDateString('id-ID');
    },
  },
  methods: {
    fetchDetail() {
      this.loading = true;
      this.axios
        .get(`program/v1/company/detail-member-redeem/${this.$route.params.id}`)
        .then((res) => res.data)
        .then((res) => {
          this.result = res.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 3e2);
        });
    },
  },
};
</script>

<style></style>
